import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Repos\\Orto_App_New\\FrontEnd\\orto-web\\src\\app\\[lng]\\(home)\\components\\HomeCarousel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Repos\\Orto_App_New\\FrontEnd\\orto-web\\src\\components\\product\\product-grid.tsx");
